module.exports = __webpack_public_path__ + "static/media/alarm1.00751e6f.mp3";